import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=55af5b7e&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=55af5b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af5b7e",
  null
  
)

export default component.exports